import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'

import { useProfileStore } from '@entities/viewer'

interface CurrentTimeReturn {
  refDate: ComputedRef<string>
  refTime: ComputedRef<string>
}

export const useCurrentTime = (): CurrentTimeReturn => {
  const profileStore = useProfileStore()

  const refDate = computed<string>(() => {
    const time = profileStore.getCurrentTime
    return time ? dayjs(time).format(DateFormat.FileDate) : ''
  })

  const refTime = computed<string>(() => {
    const time = profileStore.getCurrentTime
    return time ? dayjs(time).format(DateFormat.DefaultTime) : ''
  })

  return {
    refDate,
    refTime,
  }
}
